<template>
  <v-icon small>{{ icon }}</v-icon>
</template>

<script>

export default {
  props: {
    mediaType: {
      type: String,
      required: true
    },
    mediaFormat: {
      type: String,
      required: true
    }
  },
  computed: {
    icon () {
      if (this.mediaType === 'image') {
        if (this.mediaFormat === 'pdf') {
          return 'picture_as_pdf'
        } else {
          return 'image'
        }
      } else if (this.mediaType === 'video') {
        return 'videocam'
      } else if (this.mediaType === 'raw') {
        return 'attach_file'
      }
      return null
    }
  }
}
</script>
